import React, { useEffect, useState } from "react";

import * as Yup from "yup";

import { Formik, Form, Field } from "formik";
import { Form as BootstrapForm } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { ErrorNotification } from '../../../../../src/pages/Auth/ErrorNotification';

import PrivacyPolicy from '~/components/layout/PrivacyPolicy';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';

import api from "~/services/api";

import {
  Textfield,
  ErrorMessage,
  EyeIcon,
  DivField,
  SignInButton,
  LoadingIcon,
  PasswordCondition,
  LoginSubTitle,
} from "./styles";
import { AccessExistsModal } from '../AccessExistsModal';

function SignUpWithEmail(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorApi, setErrorApi] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false);

  const accessReducer = useSelector((state) => state.accessReducer);
  const files = accessReducer.files;

  const regex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])(?=.{8,})/;
  const SignUpSchema = Yup.object().shape({
    password: Yup.string()
      .required("Insira uma senha")
      .matches(
        regex,
        "Use oito ou mais caracteres com uma combinação de letras, números e símbolos"
      ),
    passwordConfirmation: Yup.string()
      .required("Insira a confirmação de sua senha")
      .oneOf([Yup.ref("password"), null], "As senhas não combinam"),
  });

  useEffect(() => {

    props.setShowPrivacyModal(true);
  }, []);


  function postEmail(values) {
    localStorage.removeItem('X-MFA-Hash');

    const header = {
      'Content-Type': 'application/json',
      'X-First-Access-Token': accessReducer.firstAccessToken,
    };

    const parameters = {
      method: 'POST',
      headers: header,
    };

    const body = {
      grant_type: "first_access",
      contactId: accessReducer.contact.contactId,
      password: values.password,
      passwordConfirmation: values.passwordConfirmation,
      privacyPoliciesAccepted: true,
    };

    if (accessReducer.registrationToken) {
      body.token = accessReducer.registrationToken;
    }

    api.post("/residential/store/v1/users/authentications", body, parameters)
      .then((res) => {
        const mfaToken = res.data.mfaToken;
        const mfaHash = res.headers['x-mfa-hash'];

        if (mfaToken) {
          localStorage.setItem("X-MFA-Token", mfaToken);
        }

        if (mfaHash) {
          localStorage.setItem('X-MFA-Hash', mfaHash);
        }

        dispatch({ type: "STEP", step: 6 });
        setLoading(false);
      })
      .catch((err) => {
        if (err.response?.data) {
          if (
            err.response.data.message ===
            "O login/e-mail selecionado está em uso."
          ) {
            setIsModalOpen(true)
            history.push("/");
          } else {
            setErrorApi(true)
          }
        }
        setLoading(false);
      });
  }

  const hasValidationError = (value, regex) => !value.match(regex);
  const areAllConditionsMet = (values) => {
    return (
      !hasValidationError(values.password, /.{10}/) &&
      !hasValidationError(values.password, /[A-Z]/) &&
      !hasValidationError(values.password, /[a-z]/) &&
      !hasValidationError(values.password, /[0-9]/) &&
      !hasValidationError(values.password, /[!@#$%^&*(),.?":{}|<>]/) &&
      values.password === values.passwordConfirmation &&
      values.password !== '' &&
      values.passwordConfirmation !== ''
    );
  };


  return (
    <>
      {isModalOpen &&  <AccessExistsModal isModalOpen={isModalOpen} handleClose={() => setIsModalOpen(false)} /> }
      {errorApi ? (
        <ErrorNotification isMFA={false} />
      ) : (
        <Formik
          initialValues={{ email: "", password: "" }}
          onSubmit={(values) => {
            setLoading(true);
            postEmail(values);
          }}
          validationSchema={SignUpSchema}
        >
          {({ handleChange, handleBlur, values, errors, touched }) => (
            <Form style={{ width: '100%' }} autoComplete="off">
              <BootstrapForm.Group controlId="mail">
                <Field
                  render={() => {
                    return (
                      <Textfield
                        id="mail"
                        type="text"
                        label="E-mail"
                        arial-label="Seu E-mail"
                        aria-required
                        errorCondition={errors.mail && touched.mail}
                        errorMessage={errors.mail}
                        title="Seu E-mail"
                        onBlur={handleBlur}
                        placeholder="Seu E-mail"
                        value={accessReducer.contact.selectedEmail}
                        onChange={handleChange}
                        disabled
                      />
                    );
                  }}
                  name="mail"
                />
                {errors.mail && touched.mail ? (
                  <ErrorMessage>{errors.mail}</ErrorMessage>
                ) : null}
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId="password">
                <DivField errorCondition={errors.password && touched.password}>
                  <input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    label="Senha"
                    arial-label="Senha"
                    aria-required
                    errorMessage={errors.password}
                    title="Senha"
                    onBlur={handleBlur}
                    placeholder="Senha"
                    value={values.password}
                    onChange={handleChange}
                    style={{
                      paddingRight: 47,
                      borderWidth: 0,
                      width: "100%",
                    }}
                  />
                  <EyeIcon
                    className={showPassword ? "mdi mdi-eye-off" : "mdi mdi-eye"}
                    errorCondition={errors.email && touched.email}
                    onClick={() => setShowPassword(!showPassword)}
                  />
                </DivField>
                {errors.password && touched.password ? (
                  <ErrorMessage>{errors.password}</ErrorMessage>
                ) : null}
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId="passwordConfirmation">
                <Field
                  render={() => {
                    return (
                      <Textfield
                        id="passwordConfirmation"
                        type="password"
                        label="Confirme a Senha"
                        arial-label="Confirme a Senha"
                        aria-required
                        errorCondition={
                          errors.passwordConfirmation &&
                          touched.passwordConfirmation
                        }
                        errorMessage={errors.passwordConfirmation}
                        title="Confirme a Senha"
                        onBlur={handleBlur}
                        placeholder="Confirme a Senha"
                        value={values.passwordConfirmation}
                        onChange={handleChange}
                      />
                    );
                  }}
                  name="passwordConfirmation"
                />
                {errors.passwordConfirmation && touched.passwordConfirmation ? (
                  <ErrorMessage>{errors.passwordConfirmation}</ErrorMessage>
                ) : null}
              </BootstrapForm.Group>
              <LoginSubTitle style={{ color: '#000FFF' }} className="mb-10">Atenção! A senha cadastrada deverá ter:</LoginSubTitle>
              <PasswordCondition className="mb-0" style={{ color: hasValidationError(values.password, /.{10}/) ? 'red' : 'black' }}>
                No mínimo 10 caracteres
                {hasValidationError(values.password, /.{10}/) ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
              </PasswordCondition>
              <PasswordCondition className="mb-0" style={{ color: hasValidationError(values.password, /[A-Z]/) ? 'red' : 'black' }}>
                No mínimo uma letra maiúscula
                {hasValidationError(values.password, /[A-Z]/) ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
              </PasswordCondition>
              <PasswordCondition className="mb-0" style={{ color: hasValidationError(values.password, /[a-z]/) ? 'red' : 'black' }}>
                No mínimo uma letra minúscula
                {hasValidationError(values.password, /[a-z]/) ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
              </PasswordCondition>
              <PasswordCondition className="mb-0" style={{ color: hasValidationError(values.password, /[0-9]/) ? 'red' : 'black' }}>
                No mínimo um número
                {hasValidationError(values.password, /[0-9]/) ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
              </PasswordCondition>
              <PasswordCondition className="mb-0" style={{ color: hasValidationError(values.password, /[!@#$%^&*(),.?":{}|<>]/) ? 'red' : 'black' }}>
                No mínimo um caractere especial (%#@)
                {hasValidationError(values.password, /[!@#$%^&*(),.?":{}|<>]/) ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
              </PasswordCondition>
              <PasswordCondition className="mb-0" style={{ color: (values.password !== values.passwordConfirmation || values.passwordConfirmation === '') ? 'red' : 'black' }}>
                As senhas devem corresponder
                {(values.password !== values.passwordConfirmation || values.passwordConfirmation === '') ? <ClearIcon style={{ color: 'red', marginLeft: 2, fontSize: '18px' }} /> : <DoneIcon style={{ color: '#000FFF', marginLeft: 2, fontSize: '18px' }} />}
              </PasswordCondition>
              <SignInButton
                type="submit"
                className="mt-4"
                disabled={loading || !areAllConditionsMet(values)}
                style={{
                  backgroundColor: (loading || !areAllConditionsMet(values)) ? 'gray' : '#000FFF',
                }}
                >
                {loading ? (
                  <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                ) : (
                  <span>Avançar</span>
                )}
              </SignInButton> 
            </Form>
          )}
        </Formik>
      )}
      <PrivacyPolicy
        showModal={props.showPrivacyModal}
        activeModal={props.setShowPrivacyModal}
        access_token={accessReducer.access_token}
        user={{ userId: localStorage.getItem("userId") }}
        fileData={files?.POLITICA_PRIVACIDADE}
      />
    </>
  );
  
}

export default SignUpWithEmail;
